// @flow

import { useUserInputValue } from '@tectonics/prs/user-input-values';

export function useSelectedMethod(payment_method: string): bool {
  const [paymentMethod] = useUserInputValue('selectedPaymentMethod');

  return paymentMethod === payment_method;
}
